import { useEffect, useState } from "react";

import { Spin } from "antd";

import { GoogleLogin, googleLogout, useGoogleLogin } from "@react-oauth/google";

import googleApi from "../../../../apis/Google.api";

const GoogleAnalytics = () => {
  const [isLogin, setIsLogin] = useState(false);

  const [data, setData] = useState({
    nowUser: 0,
    todayUser: 0,
  });

  const googleLogin = useGoogleLogin({
    // flow: "auth-code",
    flow: "implicit",
    clientId: process.env.REACT_APP_GA_CLIENT_ID,
    responseType: "token",
    redirect_uri: process.env.REACT_APP_HOST,
    scope:
      "https://www.googleapis.com/auth/analytics https://www.googleapis.com/auth/analytics.readonly",
    // overrideScope: true,
    onSuccess: async (tokenResponse) => {
      const accessToken = tokenResponse?.access_token;
      console.log("tokenResponse", tokenResponse);
      if (accessToken) {
        fetchData(accessToken);
      }
    },
    onError: (error) => {
      console.error("onError", error);
    },
  });

  useEffect(() => {
    const login = localStorage.getItem("ga-login");
    const gaToken = localStorage.getItem("ga-token");
    if (login === "true" && gaToken !== "null") {
      setIsLogin(true);
      fetchData(gaToken);
      const timer = setInterval(() => {
        fetchData(gaToken);
      }, 60000);
      return () => clearInterval(timer);
    } else {
      localStorage.removeItem("ga-login");
      googleLogout();
      setIsLogin(false);
      setIsLoading(false);
    }
  }, []);

  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async (accessToken) => {
    try {
      console.log("fetchDate", accessToken);
      setIsLoading(true);
      let login = false;
      localStorage.setItem("ga-token", accessToken);
      const token = `ya29.a0AfB_byBMAFXjbm84tHRaD7zyuz2zwO41bawTwi6TPyFNlF47zE3HlrpKAiyneeEEDXZ8qs9icByI6yJOgf4thkiEnGdAXFqo9WdCZL4t2CejXsogIZWRg4TKRwsvGLdTgq4xOh58mU7mJs1Pxqm1x8QadJqdI1yE69IYaCgYKAZkSARMSFQHGX2MitD1bTWjYD-b_r7P-gqXL5w0171`;

      const headers = {
        Accept: "application/json; charset=utf-8",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        // Authorization: `Bearer ${token}`,
      };
      const accessHeaders = {
        Accept: "application/json; charset=utf-8",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        // Authorization: `Bearer ${token}`,
      };
      const param = {
        dimensions: [{ name: "date" }],
        metrics: [
          // { name: "active1DayUsers" },
          { name: "activeUsers" },
          // { name: "sessions" },
        ],
        dateRanges: [{ startDate: "today", endDate: "today" }],
      };
      const result = await googleApi.runGAReport(param, headers);

      const params = {
        metrics: [{ name: "activeUsers" }],
      };
      const resultReal = await googleApi.runRealTimeGAReport(params, headers);

      const resultTest = await googleApi.runGAReport(param, accessHeaders);
      const resultRealTest = await googleApi.runGAReport(param, accessHeaders);
      console.log("accessHeaders", resultTest?.data, resultRealTest?.data);
      let value = {
        ...data,
      };

      const resData = result?.data;
      const resRealData = resultReal?.data;
      if (resData?.rows?.length) {
        let row = resData.rows;
        value = {
          ...value,
          todayUser: row[0]?.metricValues?.[0]?.value
            ? row[0]?.metricValues?.[0]?.value
            : 0,
        };
        login = true;
      }
      // console.log("runGAReport", login);
      if (resRealData?.rows?.length) {
        let row = resRealData?.rows;
        value = {
          ...value,
          nowUser: row[0]?.metricValues?.[0]?.value
            ? row[0]?.metricValues?.[0]?.value
            : 0,
        };
        login = true;
      }
      // console.log("runRealTimeGAReport", login);
      setData(value);
      setIsLogin(login);
      if (login) {
        localStorage.setItem("ga-login", "true");
      } else {
        localStorage.removeItem("ga-login");
        localStorage.removeItem("ga-token");
      }
      // console.log("login", login, value);
      setIsLoading(false);
      // console.log("result?.data", result?.data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      {/*<Button onClick={googleLogin}>구글 로그인</Button>*/}
      {!isLogin ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            position: "relative",
          }}
        >
          {isLoading && <Spin size={"small"} style={{ zIndex: 1 }} />}
          {/*<Button onClick={googleLogin}>구글 로그인</Button>*/}
          <GoogleLogin
            onSuccess={(credentialResponse) => {
              googleLogin();
            }}
            onError={() => {
              console.log("Login Failed");
            }}
            // auto_select={true}
            useOneTap={true}
          />
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            position: "relative",
          }}
        >
          {isLoading && <Spin size={"small"} />}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 3,
            }}
          >
            <img
              src={`/assets/images/now-users.png`}
              alt={"실시간"}
              style={{
                width: "0.8rem",
                height: "0.8rem",
              }}
            />
            <p style={{ fontSize: "0.9rem" }}>
              실시간 접속자수 {Number(data.nowUser)?.toLocaleString()}명
            </p>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 3,
            }}
          >
            <img
              src={`/assets/images/today-users.png`}
              alt={"금일"}
              style={{
                width: "0.8rem",
                height: "0.8rem",
              }}
            />
            <p style={{ fontSize: "0.9rem" }}>
              금일 접속자수 {Number(data.todayUser)?.toLocaleString()}명
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
export default GoogleAnalytics;
